import managementAxe from '../../services/axios-client/managementServisAxeClient';
import caller from './utilitiesSlice';

export const unReadNotifications = async () => {
  const response = await managementAxe.get(
    '/broker/dashboard/notifications-count',
  );
  caller.notificationsSuccess(response.data);
};

export const getAllNotifications = async (page) => {
  caller.getNotificationsPending();
  try {
    const response = await managementAxe.get(
      '/broker/dashboard/notifications',
      {
        params: {
          page,
        },
      },
    );

    if (response.status !== 200) {
      caller.getNotificationsRejected('Errore Interno');
      return;
    }

    caller.getNotificationsSuccess(response.data);
  } catch (error) {
    caller.getNotificationsRejected(error);
  }
};

export const resetNotifications = async () => {
  caller.getNotificationsReset();
};

// POG-DISABLED: export const checkForUnAcceptedPog = async () => {
// POG-DISABLED:   const response = await managementAxe.get(
// POG-DISABLED:     '/broker/dashboard/check-for-unaccepted-pog',
// POG-DISABLED:   );
// POG-DISABLED:   caller.getUnacceptedPogsSuccess(response.data);
// POG-DISABLED: };

export const getQuoteTypes = async () => {
  caller.getQuoteTypesPending();
  try {
    const response = await managementAxe.get(
      '/broker/dashboard/quote-types',
    );

    if (response.status !== 200) {
      caller.getQuoteTypesRejected('Errore Interno');
      return;
    }

    caller.getQuoteTypesSuccess(response.data.quoteTypes);
  } catch (error) {
    caller.getQuoteTypesRejected(error);
  }
};

export const resetQuoteTypes = async () => {
  caller.getQuoteTypesReset();
};
